export default "__VITE_ASSET__Cwk4EnKF__"